import { Box, Grid } from "@mui/material";

import { useEffect, useRef } from "react";
import { useGetNonAdminAccess } from "../../../common/hooks/useGetNonAdminAccess";
import { useGetCurrentUser } from "../../../common/hooks/useGetUser";
import { DEFAULT_CONTROL_ROOM_REFRESH_MINUTES } from "../../../leak-finder/hooks/useLazyGetUser";
import DeploymentHealthGridItem from "./dashboard/DeploymentHealthGridItem";
import FireGridItem from "./dashboard/FireGridItem";
import GasLeakGridItem from "./dashboard/GasLeakGridItem";
import GateGuardGridItem from "./dashboard/GateGuardGridItem";
import HardHatDataGridItem from "./dashboard/HardHatDataGridItem";
import LiquidLeakGridItem from "./dashboard/LiquidLeakGridItem";
import LiveViewPtControlGridItem from "./dashboard/LiveViewPtControlGridItem";
import LocationsMapGridItem from "./dashboard/LocationsMapGridItem";
import RecentGridItem from "./dashboard/RecentGridItem";
import SensoryConfigurationGridItem from "./dashboard/SensoryConfigurationGridItem";
import SmokeGridItem from "./dashboard/SmokeGridItem";
import TlmDataGridItem from "./dashboard/TlmDataGridItem";

const DataHubDashboard = (): JSX.Element => {
  const { nonAdminView } = useGetNonAdminAccess();
  const { userInfo } = useGetCurrentUser();

  const sm = nonAdminView ? 6 : 4;
  const refreshTimerRef = useRef<number | null>(null);

  // Legacy users (undefined/null) get 2-minute refresh (current behavior)
  // Only explicitly setting to 0 disables refresh
  const refreshMinutes =
    userInfo?.userSettings?.controlRoomRefreshMinutes ??
    DEFAULT_CONTROL_ROOM_REFRESH_MINUTES;

  useEffect(() => {
    // Only disable if explicitly set to 0
    if (refreshMinutes === 0) {
      return;
    }

    const start = () => {
      if (refreshTimerRef.current) return;

      refreshTimerRef.current = window.setInterval(() => {
        const isMediaOpen = document.querySelector(
          ".MuiDialog-root, .MuiModal-root, video[controls]"
        );

        if (!isMediaOpen) {
          window.location.reload();
        }
      }, refreshMinutes * 60 * 1000);
    };

    const stop = () => {
      if (refreshTimerRef.current) {
        clearInterval(refreshTimerRef.current);

        refreshTimerRef.current = null;
      }
    };

    start();

    return () => {
      stop();
    };
  }, [refreshMinutes]);

  return (
    <>
      {!nonAdminView && (
        <Grid container alignItems="center" justifyContent="center" spacing={3}>
          <Grid item xs={12} sm={sm}>
            <SensoryConfigurationGridItem />
          </Grid>
          <Grid item xs={12} sm={sm}>
            <DeploymentHealthGridItem />
          </Grid>
          <Grid item xs={12} sm={sm}>
            <LiveViewPtControlGridItem />
          </Grid>
        </Grid>
      )}
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} lg={8}>
          <RecentGridItem />
        </Grid>
        <Grid item xs={12} sm={12} lg={4}>
          <Box marginBottom="1em">
            <LocationsMapGridItem />
          </Box>

          <Box
            sx={{
              display: "grid",
              gap: 2,
            }}
          >
            <GasLeakGridItem nonAdmin={nonAdminView} />
            {/* <FireSmokeGridItem nonAdmin={nonAdminView} /> */}
            <FireGridItem nonAdmin={nonAdminView} />
            <SmokeGridItem nonAdmin={nonAdminView} />
            <HardHatDataGridItem nonAdmin={nonAdminView} />
            <GateGuardGridItem nonAdmin={nonAdminView} />
            <TlmDataGridItem nonAdmin={nonAdminView} />
            <LiquidLeakGridItem nonAdmin={nonAdminView} />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default DataHubDashboard;
